<template>
  <div class="main_content_form">
    <div class="file_upload">
      <div class="file_upload_window">
        <b-upload drag-drop multiple v-model="imageFiles" @input="fileUploaded">
          <section>
            <div class="content has-text-centered">
              <p>
                Вы можете перенести файлы в эту область для загрузки или нажать кнопку Загрузить. Возможна загрузка
                файлов .mp4, .png, .jpg, .pdf, не превышающих 2 ГБ
              </p>
              <p class="upload_file"><i class="mdi mdi-folder-open-outline"></i> Загрузить</p>
            </div>
          </section>
        </b-upload>
      </div>
    </div>
    <div class="url">
      <b-field class="video_url" type="is-info">
        <b-input disabled placeholder="URL ссылка на видео"></b-input>
      </b-field>
      <button disabled class="add_file">Добавить</button>
    </div>
    <ul class="files_list">
      <li v-for="(item, i) in stageInfo.file_materials" :key="i">
        <i class="mdi mdi-video" v-if="item.type === 3"></i>
        <i class="mdi mdi-file-pdf" v-if="item.type === 2"></i>
        <i class="mdi mdi-image" v-if="item.type === 1"></i>
        <span class="file_name">{{ item.name }}</span>
        <span class="file_size">{{ item.size }}</span>
        <span class="delete_button" @click="deleteFile(item.id)"><i class="mdi mdi-close"></i></span>
      </li>
    </ul>
    <div class="lesson_body">
      <div class="description_form">
        <TextEditor :stage-info="stageInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import TextEditor from '@/components/admin/all-courses/content/TextEditor'
import { toastInfo, toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    TextEditor
  },
  props: {
    stageInfo: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      imageFiles: [],
      filesList: []
    }
  },
  methods: {
    fileUploaded(files) {
      files.forEach((file) => {
        if (file.size >= 2000000000) {
          this.$buefy.toast.open(toastDanger('Слишком большой размер файла'))
        } else {
          if (file.type.includes('image') || file.type.includes('video') || file.type.includes('pdf')) {
            this.filesList.push(file)
            const fData = new FormData()
            fData.append('file', file)
            if (file.type.includes('video')) {
              fData.append('type', '3')
            } else if (file.type.includes('pdf')) {
              fData.append('type', '2')
            } else if (file.type.includes('image')) {
              fData.append('type', '1')
            }
            this.$axios2
              .post('courses/' + this.stageInfo.course_id + '/stages/' + this.stageInfo.id + '/files', fData, {
                headers: { 'content-type': 'multipart/form-data' }
              })
              .then(() => {
                this.$buefy.toast.open(toastInfo())
                this.$emit('saveStage')
              })
              .catch(this.$errorToast)
          } else {
            this.$buefy.toast.open(toastDanger('Выберите изображение или видео'))
          }
        }
      })
      this.imageFiles = []
    },
    deleteFile(fileId) {
      this.$axios2
        .delete('courses/' + this.stageInfo.course_id + '/stages/' + this.stageInfo.id + '/files/' + fileId)
        .then(() => {
          this.$buefy.toast.open(toastInfo())
          this.$emit('saveStage')
        })
        .catch(this.$errorToast)
    }
  }
}
</script>
